import glamorous from 'glamorous'

import { Props } from './Alert'

import { hexToRgb } from '../../../helpers/styles'

import * as colours from '../../../styles/colours'
import * as fonts from '../../../styles/typography'

export const StyledAlert = glamorous.div<Props>(
  {
    display: 'flex',
    width: '100%',
    minHeight: 45,
    padding: '12px 0',
    borderWidth: 1,
    borderStyle: 'solid',
    color: colours.basicBlMain,
    fontFamily: fonts.fontRegular,
    fontSize: 13,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    ['> p']: {
      width: '100%',
      margin: 0,
      textAlign: 'center',
    },
  },
  ({ type }) => {
    switch (type) {
      case 'warning':
        return {
          borderColor: colours.warning,
          backgroundColor: `rgba(${hexToRgb(colours.warning)}, 0.1)`,
        }
      case 'success':
        return {
          borderColor: colours.success,
          backgroundColor: `rgba(${hexToRgb(colours.success)}, 0.1)`,
        }
      default:
        return {
          borderColor: colours.error,
          backgroundColor: `rgba(${hexToRgb(colours.error)}, 0.1)`,
        }
    }
  }
)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Alert/Alert.glamorous.tsx